import "./ReadMore.scss";

import { useMemo, useState } from "react";
import { Button, Fade } from "react-bootstrap";

interface ReadMoreProps {
  text: string;
}

const MAX_WORDS = 80;

const ReadMore: React.FC<ReadMoreProps> = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const overflowInfo = useMemo(() => {
    const wordsArray = text.split(" ");
    const isOverflown = wordsArray.length > MAX_WORDS;

    return {
      isOverflown,
      shortText:
        wordsArray.slice(0, MAX_WORDS).join(" ") + (isOverflown ? "..." : ""),
    };
  }, [text]);

  return (
    <>
      {isExpanded ? text : overflowInfo.shortText}
      {overflowInfo.isOverflown && (
        <Button
          variant="link"
          className="btn-read-more"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Read less" : "Read more"}
        </Button>
      )}
    </>
  );
};

export { ReadMore };
